import React from 'react';
export function EyeHideIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17c-1.1 0-2.1-.2-3.1-.5l1-1c.6.4 1.3.6 2 .6 2.2 0 4-1.8 4-4 0-.7-.2-1.4-.6-2l1.5-1.5c1.3.9 2.4 2.1 3 3.6C18.7 15 15.6 17 12 17m-2-5c0-1.1.9-2 2-2 .2 0 .3 0 .5.1l-2.4 2.4c-.1-.1-.1-.3-.1-.5m4 0c0 1.1-.9 2-2 2-.2 0-.4 0-.5-.1l2.5-2.5v.6m-9.9 0C5.3 9 8.4 7 12 7c1.1 0 2.1.2 3 .5l-1 1c-.6-.3-1.3-.5-2-.5-2.2 0-4 1.8-4 4 0 .7.2 1.4.6 2L7 15.6c-1.3-.9-2.3-2.1-2.9-3.6m17.8-.3C21.3 9.8 20 8.2 18.4 7l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L16.6 6c-1.4-.6-2.9-1-4.6-1-4.6 0-8.6 2.7-9.9 6.7-.1.2-.1.4 0 .7.6 1.9 1.9 3.5 3.5 4.6l-2.3 2.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L7.4 18c1.4.6 3 1 4.6 1 4.6 0 8.6-2.7 9.9-6.7.1-.1.1-.4 0-.6"
  }));
}